import { useEffect, useMemo, useState } from "react";
import { Modal, Button, Tag, Empty, List, Typography } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTenant,
  selectUserState,
} from "../../../store/user/selectors";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import { setKeyValue } from "../../../store/user/slice";

const TenantsModal = () => {
  const { tenants, selectedTenantId, loading } = useSelector(selectUserState);
  const selectedTenant = useSelector(selectSelectedTenant);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname === ROUTES.BILLING) return;

    if ((!selectedTenantId || !selectedTenant?.has_premium_access) && !loading)
      setShowModal(true);
    else if (selectedTenantId && !loading) setShowModal(false);
  }, [selectedTenantId, loading, selectedTenant, window.location.pathname]);

  const formattedTenants = useMemo(
    () => Object.keys(tenants).map((key) => tenants[key]),
    [tenants],
  );

  return (
    <>
      {showModal && (
        <Modal
          title="Tenants"
          open={showModal}
          width={600}
          footer={null}
          closable={false}
        >
          {formattedTenants && formattedTenants.length > 0 ? (
            <List
              dataSource={formattedTenants}
              renderItem={(item) => (
                <List.Item key={item.email}>
                  <List.Item.Meta
                    title={
                      <div className="flex">
                        {item.name}
                        <div style={{ marginLeft: "10px" }}>
                          {item?.has_premium_access ? (
                            <Tag icon={<UnlockOutlined />} color="green">
                              Premium
                            </Tag>
                          ) : (
                            <Tag icon={<LockOutlined />} color="red">
                              No Premium
                            </Tag>
                          )}
                        </div>
                      </div>
                    }
                    description={
                      <div
                        className="flex align-center gap"
                        style={{ marginTop: 6 }}
                      >
                        <Tag color="blue" className="uppercase-text">
                          ROLE: {item.role}
                        </Tag>

                        <div>
                          {item?.has_premium_access ? (
                            <Typography.Text type="success">
                              Select and continue with this tenant..
                            </Typography.Text>
                          ) : item.role === "OWNER" ? (
                            <Typography.Text type="warning">
                              Upgrade your plan from billing to access premium
                              features.
                            </Typography.Text>
                          ) : (
                            <Typography.Text type="warning">
                              Ask your organization owner to upgrade to Premium
                            </Typography.Text>
                          )}
                        </div>
                      </div>
                    }
                  />
                  <div>
                    {item?.has_premium_access ? (
                      <Button
                        type="primary"
                        onClick={() =>
                          dispatch(
                            setKeyValue({
                              key: "selectedTenantId",
                              value: item?.id,
                            }),
                          )
                        }
                      >
                        Select
                      </Button>
                    ) : item.role === "OWNER" ? (
                      <Button
                        type="primary"
                        onClick={() => {
                          navigate(`${ROUTES.BILLING}?tenant_id=${item?.id}`);
                          setShowModal(false);
                        }}
                      >
                        Update Plan
                      </Button>
                    ) : (
                      <></>
                    )}
                  </div>
                </List.Item>
              )}
            />
          ) : (
            <Empty description="No tenants found" />
          )}
        </Modal>
      )}
    </>
  );
};

export default TenantsModal;
